module.exports = __webpack_public_path__ + "static/EVOTINCTION-3011e262201a9fcec5bcd86252b33a6f.jpg";